import { reduxForm, change, arrayPush, reset, arrayMove, formValueSelector, focus } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { hideModal, showSecondaryModal, hideSecondaryModal } from '../../../actions/ModalActions';
import { getPlaceDetails, resetAddress } from '../../../actions/website/PlacesActions';
import { selectEvent, fetchSuggestedRsvpQuestions, fetchSuggestedAttireOptions } from '../../../actions/EventActions';
import { updateEventV2, addEventV2 } from '../../../actions/website/entities/EventActions';
import EventForm from './EventForm/EventForm';


const formatEventDate = (form) => {
  const dateString = moment.utc(form.date, 'MM-DD-YYYY').format('MM-DD-YYYY');
  const startAt = moment.utc(`${dateString} ${form.start_at.hour}:${form.start_at.minute}`, 'MM-DD-YYYY h:mm a');
  const endAt = form.end_at ? moment.utc(`${dateString} ${form.end_at.hour}:${form.end_at.minute}`, 'MM-DD-YYYY h:mm a') : '';
  if (endAt !== '' && endAt.isBefore(startAt)) endAt.add(1, 'd');
  const timezone = momentTimezone.tz.guess();
  return Object.assign({}, form, { start_at: startAt.format(), end_at: endAt !== '' ? endAt.format() : null, end_time: endAt !== '' ? form.end_time : null, timezone });
};

const formatDateForEdit = (form) => {
  if (!form.date) {
    const start = moment.utc(form.start_at);
    const end = moment.utc(form.end_at);

    return {
      date: moment.utc(form.start_at),
      start_at: { hour: start.format('H'), minute: start.format('m') },
      end_at: end.isValid() ? { hour: end.format('H'), minute: end.format('m') } : undefined,
    };
  }
  return undefined;
};

const formatNewDate = date => ({
  date: date ? moment.utc(date) : moment.utc()
});

const selector = formValueSelector('eventForm');

const mapStateToProps = (state, ownProps) => ({
  initialValues: Object.assign(
    {},
    state.website.entities.byId[state.website.entities.selectedEntityId],
    state.website.entities.selectedEntityId ? formatDateForEdit(state.website.entities.byId[state.website.entities.selectedEntityId]) : formatNewDate(state.wedding.wedding.wedding_date),
    state.website.entities.selectedEntityId ? {} : { start_at: { hour: 18, minute: 0 }, public: true, collect_rsvps: ownProps.collectRsvps, country_code: 'US' }
  ),
  mealOptionCounts: state.website.entities.selectedEntityId ? state.website.entities.byId[state.website.entities.selectedEntityId].meal_option_counts : {},
  rsvpQuestionCounts: state.website.entities.selectedEntityId ? state.website.entities.byId[state.website.entities.selectedEntityId].question_answer_counts : {},
  address: state.website.entities.address,
  rsvpSuggestions: state.events.rsvp.suggestions,
  suggestedAttireOptions: state.events.events.suggestedAttireOptions,
  selectedId: state.website.entities.selectedEntityId,
  mealOptionValues: selector(state, 'meal_options'), // hack to get Meal Options to rerender whenever they are reordered
  rsvpQuestionValues: selector(state, 'rsvp_questions') // hack to get rsvp questions to rerender whenever they are reordered
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (eventFormRequest) => {
    const req = formatEventDate(eventFormRequest);
    if (eventFormRequest.id) {
      return dispatch(updateEventV2(req))
        .then(() => dispatch(hideModal()))
        .catch(() => dispatch(reset('eventForm')));
    }
    return dispatch(addEventV2(req))
      .then(() => dispatch(hideModal()));
  },
  getSuggestion: suggestionData => dispatch(getPlaceDetails(suggestionData.placeId, suggestionData.label, 'venue_name')),
  handleAddress: (address) => {
    Object.keys(address).filter(key => !!address[key]).map(key => (
      dispatch(change('eventForm', key, address[key]))
    ));
  },
  onResetAddress: (address) => {
    dispatch(resetAddress());
    Object.keys(address).map(key => dispatch(change('eventForm', key, '')));
    dispatch(change('eventForm', 'country_code', 'US'));
  },
  onResetAddressSearch: () => dispatch(resetAddress()),
  onSelectEvent: id => dispatch(selectEvent(id)),
  getRsvpSuggestions: () => dispatch(fetchSuggestedRsvpQuestions()),
  setQuestion: ({ question, id }) => dispatch(arrayPush('eventForm', 'rsvp_questions', { question, suggested_rsvp_question_id: id, editing: true })),
  getSuggestedAttireOptions: () => dispatch(fetchSuggestedAttireOptions()),
  setSelectedAttire: (attire) => {
    dispatch(focus('eventForm', 'attire'));
    dispatch(change('eventForm', 'attire', attire.attire));
    dispatch(change('eventForm', 'suggested_attire_option_id', attire.id));
  },
  onDeleteRsvpQuestion: (rsvpQuestion, deleteAction) => {
    const onConfirmAction = () => {
      deleteAction();
      dispatch(hideSecondaryModal());
    };
    const copy = {
      dek: 'Are you sure you want to delete this RSVP question?',
      warning: 'If you\'ve already collected RSVPs where guests answered this question, their data will be deleted and lost.',
      buttonText: 'Yes, Delete'
    };
    dispatch(showSecondaryModal('CONFIRM_ACTION', { onConfirmAction, copy }, { size: 'md' }));
  },
  onDeleteMealOption: (rsvpQuestion, deleteAction) => {
    const onConfirmAction = () => {
      deleteAction();
      dispatch(hideSecondaryModal());
    };
    const copy = {
      dek: 'Are you sure you want to delete this Meal Option?',
      warning: 'If you\'ve already collected RSVPs where guests selected this Meal Option, their data will be deleted and lost.',
      buttonText: 'Yes, Delete'
    };
    dispatch(showSecondaryModal('CONFIRM_ACTION', { onConfirmAction, copy }, { size: 'md' }));
  },
  onReorder: (fieldName, indexA, indexB) => dispatch(arrayMove('eventForm', fieldName, indexA, indexB)),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'eventForm',
  validate: (values) => {
    if (values.venue_name && values.venue_name.length > 50) {
      return { venue_name: 'Must be 50 characters or less' };
    }
    return undefined;
  }
})(EventForm));



// WEBPACK FOOTER //
// ./src/components/manage/common/WebsiteEventFormContainer.jsx